<template>
  <div class="full-height tkChangeCmp linear-main3">
    <ld-header
      @click-left="goback"
      :transparent="true"
      :white="true"
    />
    <div class="pad-8">
      <!--  -->
      <div class="white">
        <div class="pad-tb-20">
          <div class="font24 font-lg pad-b-5">
            <ld-icon
              :type="details.showSendCkButton==1 ? 'iconshenpi1' :
              details.showPayButton == 1 ? 'iconzhifu' :
              'icondingzuoshj-icon-Reser'"
              size="30"
              class="order-status__icon"
            />  {{ details.orderStatus }}
          </div>
          <p v-show="details.showPayButton==0&&details.showSendCkButton==0">
            改签申请已提交，请等待服务商办理！
          </p>
          <p v-show="details.showPayButton == 1">
            改签申请已提交，请请尽快完成支付！
          </p>
          <p v-show="details.showSendCkButton==1">
            改签申请已提交，请立即送审！
          </p>
        </div>
      </div>

      <div>
        <div class="pad-b-5">
          <van-cell>
            改签单号：{{ details.changeNo }}
            <span
              class="fr main-color"
              @click="lookAlterDetail(details.changeId)"
            >{{ $t('B011','查看订单') }}</span>
          </van-cell>
        </div>
        <div
          v-for="(flightItem,index) in rangeList"
          :key="index"
          class="pad-b-5"
        >
          <voyage
            :flight="flightItem"
            :showCar="flightItem.newChange"
            :show-rule="flightItem.newChange?true:false"
          >
            <van-tag
              :type="flightItem.newChange?'danger':'warning'"
              slot="tag"
            >
              <span>{{ flightItem.newChange?'改':'原' }}</span>
            </van-tag>
          </voyage>
        </div>
        <div class="pad-b-5">
          <van-cell>
            <van-row>
              <van-col span="5">{{ $t('C001','乘机人') }}：</van-col>
              <van-col
                span="19"
                class="gray"
              >
                {{ details.psg }}
                <van-tag
                  type="danger"
                  v-show="details.fsEmpId"
                >
                  {{ $t('attach','附') }}
                </van-tag>
              </van-col>
            </van-row>
          </van-cell>
        </div>
      </div>
      <ld-button
        detault
        :to="isYlslh5 ? '/tk/tkQuery' : '/home'"
      >
        {{ $t('B012','继续预订') }}
      </ld-button>
      <!--  -->
    </div>

    <!--  -->
    <ld-tabbar
      ref="tabbar"
      :price-list="priceList"
      class="bg-white shadow"
    >
      <van-row
        class="full-width pad-lr-10"
        type="flex"
        align="center"
        gutter="8"
        style="padding-right: 8px;"
      >
        <van-col span="16">
          <span class="font12">&nbsp; {{ $t('E107','改签费用') }}：</span>
          <span class="font12 red">&yen; </span>
          <span class="font16 red"> {{ details.changeAmount }}</span>
          <span
            class="font12 text-center"
            @click="toggle('tabbar')"
            style="margin-left:10px"
          >
            <span>明细</span>
            <van-icon
              name="arrow-up"
              class="vertical-middle"
              size="14"
            />
          </span>
          <!-- <span class="font10 gray"> {{ $t('E017','共') }}{{ details.orderPsgBeanList.length }}人</span>  -->
        </van-col>
        <!-- <van-col span="3"/> -->
        <van-col
          span="8"
          v-if="details.showPayButton==1 && details.changeAmount!='0.0起' && details.changeAmount!='0.00起' && details.changeAmount!='0起'"
        >
          <ld-button
            main
            size="md"
            @click="toPay()"
            :disabled="details.changeAmount=='0.0起' || details.changeAmount=='0.00起' || details.changeAmount=='0起'"
          >
            {{ $t('B014','支付') }}
          </ld-button>
        </van-col>
        <van-col
          span="8"
          v-if="details.showSendCkButton==1"
        >
          <ld-button
            main
            size="md"
            @click="sendApply"
          >
            {{ $t('B028','送审') }}
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>

    <!-- 支付 -->
    <!-- <ld-pay
      ref="pay"
      order-type="11003"
      :order-id="orderId"
    /> -->
  </div>
</template>

<script>
import ldButton from 'Common/ldButton'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import { Cell , Field ,Checkbox ,Tag, Step, Steps} from 'vant'
import voyage from 'Components/tk/voyage/voyage.vue'
// import ldPay from 'Components/ldPay/index.vue'
import { changeData } from './utils'
import defaultMixin from '../../../mixins/default'
import { isGat, toPayForGat } from 'Utils/gattools';

export default {
  template: 'tkChangeCmp',
  mixins:[defaultMixin],
  components: {
    ldButton,
    [Cell.name]:Cell,
    [Field.name]:Field,
    [Checkbox.name]:Checkbox,
    [Tag.name]:Tag,
    [Step.name]:Step,
    [Steps.name]:Steps,
    voyage,
    // ldPay,
    ldTabbar
  },
  data: function() {
    return {
      details: [],
      rangeList:[],
      priceList:[]
    }
  },
  computed:{
    orderId(){
      return this.$route.query.orderId||[]
    },
    // priceList(){
    // 	return []
    // }
  },
  mounted() {
    this.getAlterDetail()
  },
  activated(){
    this.getAlterDetail()
  },
  methods: {
    toggle(name){
      this.$refs[name].toggle()
    },
    goback(){
      this.$router.push({path:'/allOrder?findType=1'})
    },
    getAlterDetail() {
      this.$api['tkOrder/findChangeOrderByChangeId']({
        changeId:this.orderId
      }).then(resp =>{
        console.log(resp)
        this.details = resp.data && resp.data[0]||{}
        this.rangeList=changeData(this.details.rangeList)
        this.priceList=[
          {
            name: "原票价",
            price: this.details.nFcny - this.details.fcnyDiff,
            show: true,
          },
          {
            name: "新票价",
            price: this.details.nFcny,
            show: true,
          },
          {
            name: "差价",
            price: this.details.fcnyDiff,
            show: true,
          },
          {
            name: "改签手续费",
            price: this.details.cuChangeAmount,
            show: true,
          }
        ]

      })
    },
    lookAlterDetail(id) {
      this.$router.push({path:'/tk/tkChangeDetail',query:{orderId:id}})
    },
    //去送审
    sendApply(){
      this.$router.push({
        path:'/approval/Send',
        query:{
          orderId:this.details.changeId,
          orderNo:this.details.orderNo,
          orderType:this.details.orderType
        }
      })
    },
    toPay(){//支付
      // IBE 支付校验 2000039
      if ('2000039' === this.details.supplierCode) {
        // 调用改期费查询接口
        this.$api['tkOrder/tkChangeQueryFee']({
          'newPnr': this.details.nPnrNo,//新PNR
          'tknos': this.details.oTkno,//原票号
          'plane': this.details.nModel,// 机型
          'changeOrderId': this.details.changeId,// 改期订单ID
          'update': '1',// 是否更新到改期单
        }).then((res) => {
          const cache=res.data||{}
          if (this.details.nFcny !== cache.ticketFare || cache.exchangeFee !== this.details.purchanseChangeAmount) {
            this.$dialog.alert('改期费用已发生变化')
            this.getAlterDetail()
          } else {
            // 关爱通支付
            if (isGat()) {
              return toPayForGat(this.orderId, '11003');
            }
            this.$router.push({path:'/pay/payment',query:{orderType:'11003',orderId:this.orderId}})
          }
        }).catch(err => {
          console.log(err)
          this.$dialog.alert('核对改期费失败')
        })
        return
      }
      // 关爱通支付
      if (isGat()) {
        return toPayForGat(this.orderId, '11003');
      }
      this.$router.push({path:'/pay/payment',query:{orderType:'11003',orderId:this.orderId}})
      // this.$refs.pay.toggle()
    }
  }
}
</script>

<style lang="less">
.tkChangeCmp{
}
.pad-b-5{
    padding-bottom:5px;
}
.pad-8{
    padding:8px;
}
.pad-tb-20{
    padding-top:20px;
    padding-bottom:20px;
}
.pad-lr-20{
    padding-left: 20px;
    padding-right: 20px;
}

</style>
